import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./containers/Login";
import "./App.css";
import Home from "./containers/LandingPage/LandingPage";
import Layout from "./components/Layout/Layout";
import Profile from "./containers/Profile";
import View from "./containers/View";
import ViewTP from "./containers/ViewTaxPayer/ViewTaxPayer";
import Calc from "./containers/TaxCal/TaxCal";
import New from "./containers/AddTaxPayer/AddTaxPayer";
import ViewBus from "./containers/ViewBus";
import ViewBusTP from "./containers/ViewBusiness/ViewBusiness";
import Answer from "./containers/TaxCalAnswer/TaxCalAnswer";
import Settings from "./containers/Settings/Settings";
import Reset from "./containers/Reset/Reset";
import Graph from "./containers/Graphs/Graph";
import AddBus from "./containers/AddBusiness/AddBusiness";
import Update from "./containers/UpdateTaxPayer/UpdateTaxPayer";
import UpdateBusiness from "./containers/UpdateBusiness/UpdateBusiness";
import Certificate from "./containers/Certificate/Certificate";
import Qrcode from "./containers/Qrcode/Qrcode";
import { ProtectedRoute } from "./components/protectedRoute";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faIgloo } from "@fortawesome/free-solid-svg-icons";

library.add(faIgloo);

class App extends Component {
  state = {
    login: true,
  };

  render() {
    return (
      <Router>
        <Layout>
          <div className="container">
            <Switch>
              <Route exact path="/" component={Login} />
              <ProtectedRoute exact path="/profile" component={Profile} />
              <ProtectedRoute exact path="/home" component={Home} />
              <ProtectedRoute exact path="/view" component={View} />
              <ProtectedRoute exact path="/viewtp" component={ViewTP} />
              <Route exact path="/calc" component={Calc} />
              <Route exact path="/answer" component={Answer} />
              <ProtectedRoute exact path="/new" component={New} />
              <ProtectedRoute exact path="/addbus" component={AddBus} />
              <ProtectedRoute exact path="/viewbus" component={ViewBus} />
              <ProtectedRoute exact path="/viewbustp" component={ViewBusTP} />
              <ProtectedRoute exact path="/settings" component={Settings} />
              <ProtectedRoute exact path="/reset" component={Reset} />
              <ProtectedRoute exact path="/graph" component={Graph} />
              <ProtectedRoute exact path="/updateTp" component={Update} />
              <ProtectedRoute exact path="/qrcode" component={Qrcode} />
              <ProtectedRoute
                exact
                path="/updateBusTp"
                component={UpdateBusiness}
              />
              <ProtectedRoute exact path="/cert" component={Certificate} />
              <Route path="*" component={Login} />
            </Switch>
          </div>
        </Layout>
      </Router>
    );
  }
}

export default App;
